/******/ (() => {
  // webpackBootstrap
  /* eslint-disable */
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.cacheDOMElements();
      /* ===== Bind the event handlers in order to maintain the correct context of 'this' ===== */
      this.onSubmitBound = this.onSubmit.bind(this);
      /* ===== Remove the noscript elements from the DOM (javascript is enabled) ===== */
      Array.from(this.noscriptElements).forEach((element) => element.remove());
    }

    getProductScope() {
      return (
        this.closest("product-information") ||
        this.closest(".product-grid__quick-buy__module")
      );
    }

    cacheDOMElements() {
      /* ===== Cache the DOM elements ===== */
      this.form = this.querySelector("form");
      this.noscriptElements = this.querySelectorAll("noscript");
      this.sectionId = this.getAttribute("data-section-id");
      this.productInformation = this.getProductScope();
      this.cartAction =
        document.getElementById("PageContainer").dataset.cartAction;
      this.cartType = document.getElementById("PageContainer").dataset.cartType;
      this.cartCountIndicator = document.querySelectorAll(
        "[data-cart-count-indicator]"
      );
      this.giftWrapProductId = this.getAttribute("data-gift-wrap-product-id");
      this.wethemeGlobal = document.querySelector("script#wetheme-global");
      this.qtyErrorMessage = this.querySelector("[data-qty-error-message]");
    }

    connectedCallback() {
      /* ===== Set the initial state of the add to cart button ===== */
      if (!this.form) return;
      this.attachEventListeners();
    }

    attachEventListeners() {
      /* ===== Attach the event listeners to the DOM elements ===== */
      this.form.addEventListener("submit", this.onSubmitBound);
    }

    onSubmit(event) {
      /* ===== Handle the form submission ===== */
      event.preventDefault();
      this.prepareForSubmission();
    }

    prepareForSubmission() {
      /* ===== Prepare the form for submission ===== */
      this.productInformation = this.getProductScope();
      this.cacheSubmissionElements();
      if (!this.checkRequiredInputs()) return;
      this.disableBlankInputs();
      // If the form is valid, proceed with the submission
      this.showLoadingState();
      this.addItemsToCart();
    }

    cacheSubmissionElements() {
      /* ===== Cache the elements needed for form submission ===== */
      this.loadingIcon = this.form.querySelector("[data-loading-icon]");
      this.addToCartText = this.form.querySelector("[data-add-to-cart-text]");
      this.addedText = this.form.querySelector("[data-cart-added-text]");
      this.quantityInput = this.form.querySelector('[name="quantity"]');
      this.quantity = this.quantityInput
        ? parseInt(this.quantityInput.value, 10) || 1
        : 1;
    }

    disableBlankInputs() {
      if (!this.productInformation) return;
      // Select all input and textarea elements
      const elements =
        this.productInformation.querySelectorAll("input, textarea");
      this.blankElements = [];

      elements.forEach((element) => {
        // Check if the element has no value
        if (!element.value) {
          // Temporarily disable the element so that it is not included in the form submission
          element.disabled = true;
          this.blankElements.push(element);
        }
      });
    }

    enableBlankInputs() {
      // Enable the blank elements that were disabled
      this.blankElements.forEach((element) => {
        element.disabled = false;
      });
      this.blankElements = [];
    }

    fetchConfig(type = "json") {
      /* ===== Create the fetch configuration object ===== */
      return {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/${type}`,
        },
      };
    }

    checkRequiredInputs() {
      /* ===== Check if the required inputs have been filled out ===== */
      if (!this.productInformation) return true;
      const requiredInputs = Array.from(
        this.productInformation.querySelectorAll("[required]:not(:disabled)")
      );
      this.clearErrorMessages();
      const invalidInputs = requiredInputs.filter(
        (input) => !input.value.trim()
      );
      invalidInputs.forEach((input) => this.applyErrorMessage(input));
      return invalidInputs.length === 0;
    }

    clearErrorMessages() {
      /* ===== Clear the error messages from the form ===== */
      if (!this.productInformation) return;
      this.productInformation
        .querySelectorAll(".required-field-error")
        .forEach((error) => error.remove());
    }

    applyErrorMessage(input) {
      /* ===== Apply the error message to the input element if the required input is empty ===== */
      if (!input) return;
      const inputId = input.id;
      const buttonWrapper = this.querySelector(".paymentButtonsWrapper");
      const errorContainer = input
        .closest(".input-wrapper")
        ?.querySelector(".input-error-container");
      // const errorMessage =
      //   input.type == "file"
      //     ? this.translationsObject.translations.required_upload_error
      //     : this.translationsObject.translations.required_input_error;
      const errorMessage =
        input.type == "file" ? "Upload error" : "Input required error";
      const errorElement = `<span id="${inputId}" class="required-field-error errors" style="display: block;">${errorMessage}</span>`;
      const submitErrorMessage =
        input.type == "file"
          ? input.closest("file-upload")?.dataset.errorMessage
          : input.dataset.errorMessage;
      const submitErrorElement = `<span id="${inputId}Submit" class="required-field-error errors" style="display: block;">${submitErrorMessage}</span>`;
      errorContainer
        ? (errorContainer.innerHTML = errorElement)
        : input.insertAdjacentHTML("beforebegin", errorElement);
      if (buttonWrapper)
        buttonWrapper.insertAdjacentHTML("beforebegin", submitErrorElement);
      input.focus();

      // If the input has an error message, add an 'input' event listener to remove the error message
      if (input.type == "file") return;
      input.addEventListener(
        "input",
        () => {
          this.productInformation
            ?.querySelector(`#${inputId}.required-field-error`)
            ?.remove();
          this.querySelector(
            `#${inputId}Submit.required-field-error`
          )?.remove();
        },
        { once: true }
      );
    }

    giftWrapEnabled() {
      /* ===== Determine if the gift wrap product is enabled ===== */
      return (
        !!this.form.querySelector('[name="properties[Gift wrap]"]') &&
        this.giftWrapProductId !== ""
      );
    }

    async addItemsToCart() {
      /* ===== Add the item(s) to the cart ===== */
      try {
        // Add the main product to the cart
        const mainProductAdded = await this.addProductToCart(
          routes.cart_add_url,
          this.fetchConfigWithBody()
        );
        if (mainProductAdded && this.giftWrapEnabled()) {
          // Add the gift wrap product to the cart
          await this.addProductToCart(
            routes.cart_add_url,
            this.additionalProductConfig(this.giftWrapProductId, this.quantity)
          );
        }
        // Process the response
        this.processResponse(mainProductAdded);
      } catch (error) {
        console.error(
          `Error adding item(s) to cart: ${error.description || error.message}`
        );
      }
    }

    async addProductToCart(url, config) {
      /* ===== Add the product to the cart ===== */
      const response = await fetch(url, config);
      if (!response.ok) {
        console.error(
          `Error adding item to cart: ${
            response.description || response.statusText
          }`
        );
      }
      return response;
    }

    additionalProductConfig(productId, quantity) {
      /* ===== Create the configuration object for the additional product(s) to be added to the cart ===== */
      const additionalItemPayload = {
        items: [{ id: productId, quantity: quantity }],
      };
      return {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(additionalItemPayload),
      };
    }

    async getCart() {
      /* ===== Fetch the cart information ===== */
      try {
        const response = await fetch(`/cart.js`);
        //const response = await fetch(`${routes.cart_url}?view=compare`);
        return await response.json();
      } catch (error) {
        console.error(
          `Error fetching cart: ${error.description || error.message}`
        );
      }
    }

    updateCartCountIndicator() {
      /* ===== Update the cart count indicator ===== */
      console.log("updateCartCountIndicator", this.cartCountIndicator);
      if (this.cartCountIndicator.length <= 0) return;
      this.getCart().then(
        //cart => this.cartCountIndicator.textContent = cart.item_count
        //update all the cart count indicators on the page with cart.item_count
        (cart) =>
          this.cartCountIndicator.forEach(
            (indicator) => (indicator.textContent = cart.item_count)
          )
      );
      this.cartCountIndicator.forEach((item) => item.classList.remove("hide"));
    }

    fetchConfigWithBody() {
      /* ===== Create the fetch configuration object with the form data as the body ===== */
      const config = this.fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      config.body = new FormData(this.form);
      return config;
    }

    processResponse(response) {
      /* ===== Process the response from the server ===== */
      if (response.ok) {
        this.hideLoadingState();
      }

      // Handle the case where the product is out of stock
      if (response.status === 422) {
        this.hideLoadingState();
        if (this.qtyErrorMessage)
          this.qtyErrorMessage.classList.remove("hidden");
      }

      console.log(
        "Product added to the cart + PUBSLISH (PUB_SUB_EVENTS.cartUpdate)",
        this.sectionId
      );
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "product-form",
        productVariantId: this.sectionId,
        cartData: response,
      });

      // Emit the cart:added event
      eventBus.emit("cart:added", { sectionId: this.sectionId });
      // Re-enable the blank inputs
      this.enableBlankInputs();
    }

    toggleCartDrawer() {
      /* ===== Toggle the cart drawer open or closed ===== */
      this.getCart()
        .then((cart) => {
          eventBus.emit("toggle:right:drawer", {
            type: "cart",
            forceOpen: true,
            params: { cart },
          });
        })
        .catch((error) => {
          console.error(`Error fetching cart: ${error}`);
        });
    }

    showLoadingState() {
      /* ===== Show the loading state of the add to cart button ===== */
      this.toggleElements(this.addToCartText, false);
      this.toggleElements(this.loadingIcon, true, "hidden");
      this.toggleAddButton(true);
    }

    hideLoadingState() {
      /* ===== Hide the loading state of the add to cart button ===== */
      this.toggleElements(this.loadingIcon, false, "hidden");
      this.toggleCartActionDisplay();
    }

    toggleCartActionDisplay() {
      /* ===== Toggle the cart action display based on the selected action ===== */
      if (this.cartAction === "show_added_message" && this.addedText) {
        // Show the added text message and update the cart count indicator
        this.addedText.style.display = "block";
        setTimeout(() => {
          this.toggleAddToCartText(true);
          this.toggleAddButton(false);
          this.updateCartCountIndicator();
        }, 2000);
      } else if (
        this.cartType === "drawer" &&
        this.cartAction === "go_to_or_open_cart"
      ) {
        // Open the cart drawer
        this.toggleAddToCartText(true);
        this.updateCartCountIndicator();
        this.toggleCartDrawer();
        this.toggleAddButton(false);
      } else {
        // Utiliser le cart-notification au lieu de rediriger
        this.toggleAddToCartText(true);
        this.toggleAddButton(false);
        this.updateCartCountIndicator();

        // Essayer de trouver et utiliser le cart-notification
        const cartNotification = document.querySelector("cart-notification");
        if (cartNotification) {
          console.log("Using cart-notification instead of redirecting");
          // Le cart-notification sera affiché automatiquement par l'événement cartUpdate
        } else {
          console.log("No cart-notification found, but avoiding redirect");
          // Ne pas rediriger même si pas de cart-notification trouvé
        }
      }
    }

    toggleAddToCartText(show) {
      /* ===== Toggle the add to cart text and the added text message ===== */
      // Show the added text message and hide the add to cart text
      if (this.addedText)
        this.addedText.style.display = show ? "none" : "block";
      // Show the add to cart text and hide the added text message
      if (this.addToCartText)
        this.addToCartText.style.display = show ? "block" : "none";
    }

    toggleElements(element, show, className) {
      /* ===== Toggle the display of the element based on the show value ===== */
      if (!element) return;
      if (className) {
        show
          ? element.classList.remove(className)
          : element.classList.add(className);
      } else {
        element.style.opacity = show ? "block" : "none";
      }
    }

    toggleAddButton(disable = true) {
      /* ===== Toggle the state of the add to cart button ===== */
      const addButton = this.querySelector('[name="add"]');
      if (!addButton) return;

      addButton.disabled = disable;
    }

    disconnectedCallback() {
      /* ===== Remove the event listeners when the element is removed from the DOM ===== */
      this.form.removeEventListener("submit", this.onSubmitBound);
    }
  }

  if (!customElements.get("product-form")) {
    customElements.define("product-form", ProductForm);
  }

  /******/
})();
